export default __webpack_public_path__ + "static/media/Bin.372e82ba.svg";